/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChecklistItem
 */
export interface ChecklistItem {
    /**
     * 
     * @type {string}
     * @memberof ChecklistItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItem
     */
    machinePartId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItem
     */
    machinePartName?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItem
     */
    question?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItem
     */
    type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChecklistItem
     */
    required?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecklistItem
     */
    orderIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof ChecklistItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof ChecklistItem
     */
    minValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecklistItem
     */
    maxValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecklistItem
     */
    warningMin?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecklistItem
     */
    warningMax?: number;
}

/**
 * Check if a given object implements the ChecklistItem interface.
 */
export function instanceOfChecklistItem(value: object): value is ChecklistItem {
    return true;
}

export function ChecklistItemFromJSON(json: any): ChecklistItem {
    return ChecklistItemFromJSONTyped(json, false);
}

export function ChecklistItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChecklistItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'machinePartId': json['machinePartId'] == null ? undefined : json['machinePartId'],
        'machinePartName': json['machinePartName'] == null ? undefined : json['machinePartName'],
        'question': json['question'] == null ? undefined : json['question'],
        'description': json['description'] == null ? undefined : json['description'],
        'type': json['type'] == null ? undefined : json['type'],
        'required': json['required'] == null ? undefined : json['required'],
        'orderIndex': json['orderIndex'] == null ? undefined : json['orderIndex'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'minValue': json['minValue'] == null ? undefined : json['minValue'],
        'maxValue': json['maxValue'] == null ? undefined : json['maxValue'],
        'warningMin': json['warningMin'] == null ? undefined : json['warningMin'],
        'warningMax': json['warningMax'] == null ? undefined : json['warningMax'],
    };
}

export function ChecklistItemToJSON(value?: ChecklistItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'machinePartId': value['machinePartId'],
        'machinePartName': value['machinePartName'],
        'question': value['question'],
        'description': value['description'],
        'type': value['type'],
        'required': value['required'],
        'orderIndex': value['orderIndex'],
        'imageUrl': value['imageUrl'],
        'minValue': value['minValue'],
        'maxValue': value['maxValue'],
        'warningMin': value['warningMin'],
        'warningMax': value['warningMax'],
    };
}

